import React, { useRef } from "react";
import "../NewArrivalProduct.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import BlogDetails from "./BlogDetails";
import { Link } from "react-router-dom";


const Blogs = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const blogs = [
    { img: "assets/images/blog/medium-size/2.jpg", day: "10", month: "Oct", title: "Gt wisi enim ad minim veniam.", desc: "Aenean vestibulum pretium enim, non commodo urna volutpat vitae. Pellentesque vel lacus", link: "blog-details-left-sidebar.html" },
    { img: "assets/images/blog/medium-size/3.jpg", day: "05", month: "Oct", title: "Ht wisi enim ad minim veniam..", desc: "Aenean vestibulum pretium enim, non commodo urna volutpat vitae. Pellentesque vel lacus", link: "blog-details-left-sidebar.html" },
    { img: "assets/images/blog/medium-size/4.jpg", day: "20", month: "Oct", title: "Neque suscipit veniam", desc: "Aenean vestibulum pretium enim, non commodo urna volutpat vitae. Pellentesque vel lacus", link: "blog-details-left-sidebar.html" },
    { img: "assets/images/blog/medium-size/2.jpg", day: "25", month: "Oct", title: "Excepturi deleniti molestias", desc: "Aenean vestibulum pretium enim, non commodo urna volutpat vitae. Pellentesque vel lacus", link: "blog-details-left-sidebar.html" },
    { img: "assets/images/blog/medium-size/3.jpg", day: "15", month: "Oct", title: "Cum deserunt aperiam", desc: "Aenean vestibulum pretium enim, non commodo urna volutpat vitae. Pellentesque vel lacus", link: "blog-details-left-sidebar.html" },
  ];

  return (
    <div className="hiraola-banner_area-2 py-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="discover-heading">
        <span>New</span>
        <h2>BLOGS</h2>
      </div>
          </div>
          <div className="col-lg-12" style={{ position: "relative" }}>
            {/* Swiper Slider */}
            <Swiper
              modules={[Navigation]}
              loop={blogs.length > 3} // loop only if more than visible slides
              spaceBetween={30}
              slidesPerView={3} // default large screens
              navigation={{
                prevEl: prevRef.current,
                nextEl: nextRef.current,
              }}
              onBeforeInit={(swiper) => {
                swiper.params.navigation.prevEl = prevRef.current;
                swiper.params.navigation.nextEl = nextRef.current;
              }}
              breakpoints={{
                0: { slidesPerView: 1 },
                576: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                992: { slidesPerView: 3 },
              }}
            >
              {blogs.map((blog, index) => (
                <SwiperSlide key={index}>
                  <div className="blog-slide_item">
                    <div className="blog-item">
                      <div className="blog-img img-hover_effect">
                        <a href="/BlogDetails">
                          <img src={blog.img} alt="Hiraola's Blog Image" />
                        </a>
                        <div className="blog-meta-2">
                          <div className="blog-time_schedule">
                            <span className="day">{blog.day}</span>
                            <span className="month">{blog.month}</span>
                          </div>
                        </div>
                      </div>
                      <div className="blog-content">
                        <div className="blog-heading">
                          <h5>
                            <a href="/BlogDetails">{blog.title}</a>
                          </h5>
                        </div>
                        <div className="blog-short_desc">
                          <p>{blog.desc}</p>
                        </div>
                        <div className="hiraola-read-more_area">
                          <a href="/BlogDetails" className="hiraola-read_more">Read More</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            <div className="text-center mt-4"><a className="view-all-btn text-decoration-none d-inline-block" href="/collection/All" data-discover="true">View All</a></div>

            {/* Custom Arrows */}
            {/* <button
              ref={prevRef}
              className="custom-prev slick-arrow"
              style={{
                position: "absolute",
                top: "50%",
                left: "-25px",
                zIndex: 10,
                transform: "translateY(-50%)",
              }}
            >
              <i className="ion-ios-arrow-back"></i>
            </button>
            <button
              ref={nextRef}
              className="custom-next slick-arrow"
              style={{
                position: "absolute",
                top: "50%",
                right: "-25px",
                zIndex: 10,
                transform: "translateY(-50%)",
              }}
            >
              <i className="ion-ios-arrow-forward"></i>
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blogs;
